import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changeset from 'ember-changeset/helpers/changeset';
import t from 'ember-intl/helpers/t';
import add from 'ember-math-helpers/helpers/add';
import type { ModelListItem } from 'parog-web/components/model-list';
import Dropdown from 'ui-kit/components/changeset/dropdown';
import DatePicker from '../../../changeset/date-picker';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    item: ModelListItem;
  };
}

export default class TreatmentHistoryEditionFormChemotherapyOncoLungCancerComponent extends Component<Signature> {
  get chemotherapyProtocols() {
    return [
      '3-fec-100-3-taxotere',
      '3-fec-100-9-weekly-taxol',
      '3-fec-100-12',
      '4-tc',
      '12-weekly-taxol',
      '12-taxol-3-ec',
      '3-ec-9-weekly-taxol',
      '4-ec-9-taxol',
      '6-ec-9-taxol',
      '6-taxotere'
    ];
  }

  get #chemotherapies() {
    return this.args.changeset.get('chemotherapies');
  }

  onChangesetUpdate = (changeset: EmberChangeset) => {
    changeset.execute();
    this.#setAsDirty();
  };

  #setAsDirty() {
    this.args.changeset.set('chemotherapies', [].concat(this.#chemotherapies));
  }

  <template>
    {{#let (changeset @item.item) as |chemotherapiesChangeset|}}
      <div class='ui segment' data-test-chemotherapy-list-item={{@item.index}}>
        <h3 class='ui dividing header'>Chimiothérapie
          {{add @item.index 1}}</h3>
        <div class='absolute right-0 top-0 mr-2 mt-4'>
          <i class='trash icon' role='button' {{on 'click' @item.destroy}}>
          </i>
        </div>
        <div>
          <div class='field'>
            <DatePicker
              @changeset={{chemotherapiesChangeset}}
              @labelName='Cure 1'
              @propertyName='therapyOne'
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @changeset={{chemotherapiesChangeset}}
              @labelName='Cure 2'
              @propertyName='therapyTwo'
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @changeset={{chemotherapiesChangeset}}
              @labelName='Cure 3'
              @propertyName='therapyThree'
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @changeset={{chemotherapiesChangeset}}
              @labelName='Cure 4'
              @propertyName='therapyFour'
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @changeset={{chemotherapiesChangeset}}
              @labelName='Cure 5'
              @propertyName='therapyFive'
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <DatePicker
              @changeset={{chemotherapiesChangeset}}
              @labelName='Dernière cure'
              @propertyName='lastTherapy'
              @onChangesetUpdate={{this.onChangesetUpdate}}
            />
          </div>
          <div class='field'>
            <Dropdown
              @changeset={{chemotherapiesChangeset}}
              @labelName='Protocole de chimiothérapie'
              @propertyName='protocol'
              @onChangesetUpdate={{this.onChangesetUpdate}}
              as |dropdown|
            >
              {{#each this.chemotherapyProtocols as |chemotherapyProtocol|}}
                <dropdown.Item
                  @key={{chemotherapyProtocol}}
                  @value={{t
                    (concat 'chemotherapy-protocol.' chemotherapyProtocol)
                  }}
                />
              {{/each}}
            </Dropdown>
          </div>
        </div>
      </div>
    {{/let}}
  </template>
}
